/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingModelEnum = 'COMMIT_REQUIRED' | 'COMMIT_OPTIONAL' | 'COMMIT_ONLY';

export const BillingModelEnum = {

    COMMIT_REQUIRED: 'COMMIT_REQUIRED' as BillingModelEnum,

    COMMIT_OPTIONAL: 'COMMIT_OPTIONAL' as BillingModelEnum,

    COMMIT_ONLY: 'COMMIT_ONLY' as BillingModelEnum
};

